import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export interface ScopedRouteInfo {
  scopedItem: any;
  basePath: string;
  eventId?: number;
}

export function useScopedRoute(): ScopedRouteInfo | null {
  const { pathname } = useLocation();

  return useMemo(() => {
    try {
      const raw = localStorage.getItem("sidePanel");
      if (!raw) return null;
      const decoded = JSON.parse(atob(raw));
      for (const item of decoded) {
        if (
          item.is_scoped &&
          pathname.startsWith(item.link + "/") &&
          pathname !== item.link
        ) {
          const scopedSegments = item.link.split("/").filter(Boolean);
          const currentSegments = pathname.split("/").filter(Boolean);
          const idSegment = currentSegments[scopedSegments.length];
          const basePath = idSegment
            ? `${item.link}/${idSegment}`
            : item.link;
          const eventId = idSegment ? Number(idSegment) : undefined;
          return { scopedItem: item, basePath, eventId };
        }
      }
      return null;
    } catch {
      return null;
    }
  }, [pathname]);
}
